import { buttonBaseClasses } from '@mui/material/ButtonBase';
import type { CSSObject, Theme } from '@mui/material/styles';

import { sizeVariants } from 'theme/theme.helpers';

export const SELECTION_CONTROL_PADDING_PX = { medium: 6, small: 4 } as const;

export type SelectionControlSize = keyof typeof SELECTION_CONTROL_PADDING_PX;

const LABEL_SPACING_PX = 4;

export const SELECTION_CONTROL_LABEL_GAP_PX = {
  medium: SELECTION_CONTROL_PADDING_PX.medium + LABEL_SPACING_PX,
  small: SELECTION_CONTROL_PADDING_PX.small + LABEL_SPACING_PX,
} as const satisfies Record<SelectionControlSize, number>;

export const SELECTION_CONTROL_ACTIVE_STATES = [
  '&:hover',
  '&:active',
  `&.${buttonBaseClasses.focusVisible}`,
] as const;

export const selectorsWithin = (states: readonly string[], part: string) =>
  states.map((state) => `${state} ${part}`).join(', ');

export const selectionControlSizeVariants = sizeVariants(
  SELECTION_CONTROL_PADDING_PX,
  (size) => ({
    padding: SELECTION_CONTROL_PADDING_PX[size],
    margin: -SELECTION_CONTROL_PADDING_PX[size],
  })
);

export const selectionControlHalo = (theme: Theme): CSSObject => ({
  '&:hover': {
    backgroundColor: theme.palette.secondary.lighter,
    '@media (hover: none)': {
      backgroundColor: 'transparent',
    },
  },
  [`&:active, &.${buttonBaseClasses.focusVisible}`]: {
    backgroundColor: theme.palette.secondary.lighter,
  },
});
